<template>
  <div class="">
    <NavEL></NavEL>
    <AdminLogin></AdminLogin>
  </div>
</template>

<script>
export default {
  components: {
    ...require('../kit.js').default
  }
}
</script>

<style>

</style>
